"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

const LiveStream = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 14,
  height: 10,
  viewBox: "0 0 14 10",
  fill: "none"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  d: "M3.362.334a.58.58 0 00-.821-.008A6.584 6.584 0 00.6 5a6.584 6.584 0 002.083 4.812.58.58 0 00.808-.02.623.623 0 00-.021-.888A5.384 5.384 0 011.8 5a5.38 5.38 0 011.554-3.79.623.623 0 00.008-.876zm1.41 1.41a.571.571 0 00-.807-.013A4.584 4.584 0 002.6 5c0 1.354.584 2.57 1.514 3.412a.57.57 0 00.787-.03c.262-.263.213-.676-.033-.908A3.392 3.392 0 013.8 5c0-.92.366-1.755.96-2.368.229-.235.266-.634.011-.888zm4.457 0a.571.571 0 01.806-.014A4.584 4.584 0 0111.4 5c0 1.354-.584 2.57-1.514 3.412a.57.57 0 01-.787-.03c-.262-.263-.213-.676.033-.908A3.392 3.392 0 0010.2 5a3.39 3.39 0 00-.96-2.368c-.229-.235-.266-.634-.011-.889zm1.409-1.41a.58.58 0 01.821-.008A6.585 6.585 0 0113.4 5a6.585 6.585 0 01-2.083 4.812.58.58 0 01-.808-.02.622.622 0 01.022-.888A5.385 5.385 0 0012.2 5a5.38 5.38 0 00-1.554-3.79.623.623 0 01-.008-.876zM7 3.8a1.2 1.2 0 100 2.4 1.2 1.2 0 000-2.4z",
  fill: "#ACB3BE",
  className: "fill"
}));

var _default = LiveStream;
exports.default = _default;